import React, { Component } from 'react'
import { Button, Container, Row, Col, Form } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav } from '../../helpers'
import MyPDF from './companyAndAddress.xlsx';

import Calendar from 'react-calendar'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
class CheckWeightCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: false,
      completedLoading: false,
      CompanyList: [],
      startDate: new Date(),
      isLoading: true,
    }
    this.onChange = this.onChange.bind(this)
    this.handleSelectDate = this.handleSelectDate.bind(this)
  }
  componentDidMount() {
    console.log(new Date(this.props.location?.state?.timeValue))
    console.log(this.props.location?.state?.timeValue)
    this.setState({
      ...this.state,
      isLoading: false,
      startDate: new Date(this.props.location?.state?.timeValue)
    })
  }
  renderDate(dateObj) {
    if (dateObj.split('-')[1] == '02' && dateObj.split('-')[2] == '29') {
      return `28/2/2564`
    } else {
      let dateParser = new Date(dateObj)
      let day = dateParser.getDate()
      let month = dateParser.getMonth() + 1
      let years = dateParser.getFullYear() + 543
      return `${day}/${month}/${years}`

    }
  }

  onChange = (date) => {
    console.log(date)
    let startDate = new Date(date[0])
    let endDate = new Date(date[1])
    // date = new Date(date)
    console.log(endDate)
    let days = startDate.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(startDate.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = startDate.getFullYear()
    startDate = `${year}-${month}-${days}`


    days = endDate.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    month = parseInt(endDate.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    year = endDate.getFullYear()
    endDate = `${year}-${month}-${days}`
    console.log(endDate)
    this.setState({
      ...this.state,
      startDate: startDate,
      endDate: endDate,
    })
    // this.props.history.push({
    //   pathname: '/FinancialWageMonthlyTable',
    //   state: {
    //     startDate : startDate,
    //     endDate : endDate
    //   },
    // })
  }
  handleSelectDate(e) {
    let dateArr = e.target.value.split(',')
    this.onChange(dateArr)
  }
  onChangeDate = (dates) => {
    const [start, end] = dates
    this.setState({
      ...this.state,
      startDate: start,
      endDate: end
    })
  }
  goCalculateWage = (startDate, endDate) => {
    console.log(startDate, endDate)
    this.props.history.push({
      pathname: '/FinancialWageTable',
      state: {
        startDate: startDate,
        endDate: endDate
      },
    })
  }

  goFinancialWageSetting = () => {
    this.props.history.push({
      pathname: '/FinancialWageSetting',
    })
  }
  goFinancialWageVehicle = () => {
    this.props.history.push({
      pathname: '/FinancialWageVehicle',
    })
  }
  goFinancialWageCompany = () => {
    this.props.history.push({
      pathname: '/EditCompany',
    })
  }

  goToSumWage = (startDate, endDate ,) => {
    this.props.history.push({
      pathname: '/FinancialWageMonthlyTable',
      state: {
        startDate: startDate,
        endDate: endDate,
      }
    })
  }
  goToSumWageMonthly = (startDate, endDate) => {
    this.props.history.push({
      pathname: '/FinancialWageMonthlyTableMonthly',
      state: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  render() {
    if (!this.state.isLoading) {
      let dateArr = []
      dateArr.push({
        startDate: `2020-12-16`,
        endDate: `2020-12-31`,
        title: 'งวดที่ 1'
      })

      for (let index = 0; index < 23; index++) {
        let monthStart = 0
        let monthEnd = 0
        let dayStart = 0
        let dayEnd = 0
        let titleDay = ''
        if (index % 2 == 0) {
          dayStart = '01'
          dayEnd = '15'
          titleDay = 'งวดที่ 2'

          monthStart = Math.floor(index / 2) + 1
          if (monthStart < 10) {
            monthStart = `0${monthStart}`
          }
          monthEnd = Math.floor(index / 2) + 1
          if (monthEnd < 10) {
            monthEnd = `0${monthEnd}`
          }

        } else {
          dayStart = '16'
          dayEnd = '31'
          titleDay = 'งวดที่ 1'
          monthStart = Math.floor(index / 2) + 1
          if (monthStart < 10) {
            monthStart = `0${monthStart}`
          }
          monthEnd = Math.floor(index / 2) + 1
          if (monthEnd < 10) {
            monthEnd = `0${monthEnd}`
          }
          if (monthEnd == '04' || monthEnd == '06' || monthEnd == '09' || monthEnd == '11') {
            dayEnd = '30'
          } else if (monthEnd == '02') {
            dayEnd = '28'
          }
        }

        dateArr.push({
          startDate: `2021-${monthStart}-${dayStart}`,
          endDate: `2021-${monthEnd}-${dayEnd}`,
          title: titleDay
        })
      }
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Container fluid>
            <Row style={{ height: '50vh' }}>
              <Col>
                <Calendar
                  onChange={this.onChange}
                  selectRange={true}
                // value ={}
                />
              </Col>
              <Col style={{ height: '50vh', overflow: 'scroll' }} xs={7}>
                {(() => {
                  return (
                    <Form.Group onChange={this.handleSelectDate}>
                      <Form.Label>รายงวด</Form.Label>
                      <Form.Control as="select" >
                        {
                          dateArr.map((data, idx) => {
                            return (<option value={`${data['startDate']},${data['endDate']}`}> {data['title']} เดือน {Math.floor(idx / 2) + 1}  || วันที่ {this.renderDate(data['startDate'])} ถึงวันที่ {this.renderDate(data['endDate'])} </option>)
                          })
                        }
                      </Form.Control>
                    </Form.Group>
                  )
                })()}

                {(() => {
                  return (
                    <Form.Group onChange={this.handleSelectDate}>
                      <Form.Label>รายเดือน</Form.Label>
                      <Form.Control as="select" >
                        {
                          dateArr.map((data, idx) => {
                            if (idx % 2 == 0) {
                              return (<option value={`${data['startDate']},${dateArr[idx+1]['endDate']}`}>เดือน {Math.floor(idx / 2) + 1}  || วันที่ {this.renderDate(data['startDate'])} ถึงวันที่ {this.renderDate(dateArr[idx+1]['endDate'])} </option>)
                            }
                          })
                        }
                      </Form.Control>
                    </Form.Group>
                  )
                })()}

                <Row>
                  <Button style={{ margin: '0.5em' }} onClick={() => { this.goCalculateWage(this.state.startDate, this.state.endDate) }}> คำนวนค่าแรง </Button>
                  <Button style={{ margin: '0.5em' }} onClick={() => { this.goToSumWage(this.state.startDate, this.state.endDate) }}> สรุปค่าแรง </Button> <br /> <br />
                  <Button style={{ margin: '0.5em' }} onClick={() => { this.goToSumWageMonthly(this.state.startDate, this.state.endDate) }}> สรุปค่าแรงรายเดือน </Button> <br /> <br />
                  <Button style={{ margin: '0.5em' }} onClick={this.goFinancialWageSetting}> ไปยังหน้าตั้งค่าวันหยุด </Button>
                  <Button style={{ margin: '0.5em' }} onClick={this.goFinancialWageVehicle}> ไปยังหน้าตั้งค่าพาหนะ </Button>
                  <Button style={{ margin: '0.5em' }} onClick={this.goFinancialWageCompany}> ไปยังหน้าตั้งค่าบริษัท </Button>
                  <Button style={{ margin: '0.5em' }} href={MyPDF} download >  ดาวน์โหลดข้อมูลบริษัท </Button>
                </Row>


              </Col>
            </Row>
          </Container>
          <br />
          {/* <Button onClick={() => { this.goCalculateWage() }}> งวดที่ 1 เดือน มค </Button> */}
          {/* <Button onClick={() => { this.goCalculateWage(this.state.startDate, this.state.endDate) }}> คำนวนค่าแรง </Button> */}
        </Container>
      )
    } else {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Calendar
            // onChange={this.onChange}
            selectRange={true}
          />
        </Container>
      )
    }

  }
}
export default withRouter(CheckWeightCalendar)
